<template>
  <div class="container1">
    <img
      class="bg"
      prefetch
      src="https://oss.turingsenseai.com/1642581339246032822.png"
      alt=""
    />

    <div class="card" @click="select({ name: 1 })">
      <div class="left">
        <div class="left1">门头照</div>
        <div class="left2">CERTIFICATES</div>
      </div>
      <div class="right">
        <img src="https://oss.turingsenseai.com/1642666019819575341.png" />
      </div>
    </div>

    <div class="card" @click="select({ name: 2 })">
      <div class="left">
        <div class="left1">特殊资质</div>
        <div class="left2">LICENSE</div>
      </div>
      <div class="right">
        <img src="https://oss.turingsenseai.com/1642666817098396356.png" />
      </div>
    </div>
    <!-- <div class="card" @click="select({name: 3})">
      <div class="left">
        <div class="left1">自然图片</div>
        <div class="left2">PICTURE</div>
      </div>
      <div class="right">
        <img src="https://oss.turingsenseai.com/1643012109575552169.png">
      </div>
    </div> -->
    <div></div>
  </div>
</template>

<script>
import { Toast, ImagePreview } from "vant";
import jsCookies from "js-cookie";

Toast.setDefaultOptions({ duration: 1000000 });
export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      takePhoto: false,
      success: false,
      loading: false,
      imgUrl: null,
      data: {},
    };
  },
  beforeCreate() {
    console.log(this.$route.query.token);
    if (this.$route.query) {
      jsCookies.set("token", this.$route.query.token);
    }
  },
  created() {},
  methods: {
    select({ name }) {
      // this.$router.push(`ps/select?category=${name}`);
      this.$router.push(`ps/stage?type=${name}&category=${name}`);
    },
    async afterRead(file) {},
  },
};
</script>

<style lang="scss">
.container1 {
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .card {
    width: 634px;
    height: 280px;
    margin: 0 auto;
    background: linear-gradient(
      190.61deg,
      rgba(255, 255, 255, 0.52) 19.29%,
      rgba(248, 248, 255, 0.8) 54.41%,
      rgba(255, 255, 255, 0.77) 90.02%
    );
    backdrop-filter: saturate(180%) blur(5px);
    position: relative;
    border-radius: 56px;
    margin-top: 50px;
    box-shadow: -8.22948px 39.9926px 115.213px rgba(58, 148, 255, 0.11);
    display: flex;
    .left {
      height: 280px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // align-items: center;
      margin-left: 60px;
      .left1 {
        color: #1e77e1;
        font-size: 50px;
        white-space: nowrap;
      }
      .left2 {
        margin-top: 10px;
        color: #3a94ff;
        font-size: 34px;
        font-style: normal;
        font-weight: 600;
        letter-spacing: 0px;
        opacity: 0.5;
      }
    }

    .right {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
      // justify-content: center;
      img {
        width: 224px;
        position: absolute;
        right: 48px;
      }
    }
  }
}
</style>
